module.exports = "../images/best-times-to-catch-walleye@2x.jpg?v=8f234b5";